const AUSTRIA = "AT";
const GERMANY = "DE";
const ITALY = "IT";

export const EU_INCLUDE_FEES_COUNTRIES = [AUSTRIA, GERMANY, ITALY];
